export const ORDER_RETURN_REASON_LIST_REQUEST =
  'ORDER_RETURN_REASON_LIST_REQUEST';
export const ORDER_RETURN_REASON_LIST_SUCCESS =
  'ORDER_RETURN_REASON_LIST_SUCCESS';
export const ORDER_RETURN_REASON_LIST_FAIL = 'ORDER_RETURN_REASON_LIST_FAIL';

export const ORDER_RETURN_REASON_GET_SELECTION_SUCCESS =
  'ORDER_RETURN_REASON_GET_SELECTION_SUCCESS';
